import { Route, Routes } from 'react-router-dom'

import { NotFound } from '../common/NotFound'
import AuditList from './List'

export const Audit = () => {
  return (
    <Routes>
      <Route index element={<AuditList />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}
